import { render, staticRenderFns } from "./editHousekeepingFeeType.vue?vue&type=template&id=f64c4252"
import script from "./editHousekeepingFeeType.vue?vue&type=script&lang=js"
export * from "./editHousekeepingFeeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports